// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button:hover .icon[data-v-2a0ea2ba] {\n  fill: #094c8b;\n}\n.icon[data-v-2a0ea2ba] {\n  fill: #1A7BEE;\n}", ""]);
// Exports
module.exports = exports;
